export const HELPER_IS_DNS: () => boolean = () => {
  if (window.location.pathname.split('/').includes('hotel')) {
    return false
  } else {
    return true
  }
}
